import { render, staticRenderFns } from "./writtendictation.vue?vue&type=template&id=5fe0d0b0&scoped=true&"
import script from "./writtendictation.vue?vue&type=script&lang=js&"
export * from "./writtendictation.vue?vue&type=script&lang=js&"
import style0 from "./writtendictation.vue?vue&type=style&index=0&id=5fe0d0b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe0d0b0",
  null
  
)

export default component.exports